import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const Postal3 = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [country, setCountry] = useState("es");
  const [typeOfCall, setTypeOfCall] = useState("normal");
  const [leadType, setLeadType] = useState("p3_cambio_clave");
  const [numeroPlazasC1, setNumeroPlazasC1] = useState("32");
  const [numeroPlazasC2, setNumeroPlazasC2] = useState("252");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const fromNumber = "447414695890";
    const agentID =
      typeOfCall == "normal"
        ? "agent_e5b7bda23298bb22eff4533929"
        : "agent_4e605233be1a5073b06bcdfb57";
    const baseUrl =
      "https://initiateretellcall-655075094783.us-central1.run.app";

    const url = `${baseUrl}?lead_first_name=${userFirstName}&to_number=${phoneNumber}&from_number=${fromNumber}&agent_id=${agentID}&numero_de_plazas_c1=${numeroPlazasC1}&numero_de_plazas_c2=${numeroPlazasC2}&lead_type=${leadType}`;

    console.log(`Starting call with URL ${url}`);

    await axios
      .request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => console.log(res));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              color: '#FFFFFF',
              fontSize: '2rem',
              fontWeight: 'bold',
              margin: '1rem',
            }}>
              Postal3 DEMO Español
            </h1>
            <div style={{
              height: '4px',
              width: '100px',
              background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>
          <h3 style={{
            textAlign: 'center',
            color: '#d0d0d0',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto 1.5rem auto'
          }}>
            Oposiciones de Administrativos y
            Auxiliares Administrativos de la Comunidad de Madrid
          </h3>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>

              <>
                <Select
                  value={typeOfCall}
                  onChange={(e) => {
                    setTypeOfCall(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="normal">
                    Acento neutro
                  </MenuItem>
                  <MenuItem value="gallego">
                    Acento gallego
                  </MenuItem>
                </Select>
                <Select
                  value={leadType}
                  onChange={(e) => {
                    setLeadType(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="p3_cambio_clave">
                    Script A
                  </MenuItem>
                  <MenuItem value="p3_sabias_que">
                    Script B
                  </MenuItem>
                </Select>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                  <TextField
                    label="Numero de plazas C1"
                    variant="filled"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    value={numeroPlazasC1}
                    onChange={(e) => setNumeroPlazasC1(e.target.value)}
                    required
                  />
                  <TextField
                    label="Numero de plazas C2"
                    variant="filled"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px"
                    }}
                    fullWidth
                    value={numeroPlazasC2}
                    onChange={(e) => setNumeroPlazasC2(e.target.value)}
                    required
                  />
                </Stack>
                <TextField
                  label="Nombre del lead"
                  variant="filled"
                  sx={{
                    color: "white",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  // margin="normal"
                  value={userFirstName}
                  onChange={(e) => setUserFirstName(e.target.value)}
                  required
                />
              </>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormControl sx={{ flex: { sm: '0 0 25%' } }}>
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    required
                  >
                    <MenuItem value="es">🇪🇸 (+34)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                    <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ flex: { sm: '1' } }}>
                  <PhoneInput
                    country={country}
                    value={phoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setPhoneNumber}
                    enableLongNumbers={true}
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    required
                  />
                </Box>
              </Stack>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 30px',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                    background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Haga clic aquí para recibir la llamada DEMO
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',

                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                {/* Text Content */}
                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  Después de hacer clic para recibir la llamada DEMO, recibirá una
                  llamada desde el siguiente número de teléfono:
                  <b style={{ color: '#005a9c' }}> +44 7414695890</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
